import { Component, OnInit, Input } from "@angular/core";
import { BvCardComponent, BvCardHeaderComponent, BvCardTitleComponent, BvCardBodyComponent } from "../../design-system/primitives/card.component";

@Component({
    selector: "app-blocker",
    templateUrl: "./blocker.component.html",
    styleUrls: ["./blocker.component.css"],
    imports: [BvCardComponent, BvCardHeaderComponent, BvCardTitleComponent, BvCardBodyComponent]
})
export class BlockerComponent implements OnInit {
  @Input() title!: string;
  @Input() message!: string;
  constructor() {}

  ngOnInit() {}
}
